import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTransactions } from 'contexts/Transactions';
import TableLabel from '../TableLabel';

const TableHeader = () => {
  const { t, ready } = useTranslation(['tableHeaderTitle', 'history']);
  const { rewardCustomersIsEnabled } = useTransactions();

  if (!ready) {
    return <div>Carregando tradução...</div>;
  }

  let titles = t('title', { returnObjects: true }) as Array<string>;

  if (!rewardCustomersIsEnabled) {
    titles = titles.filter((item) => item !== 'Destino');
  }

  return (
    <tr className="table-beneficiaries-header" data-testid="test-table-header">
      {titles.map((item) => (
        <th key={item}>
          <TableLabel title={item} />
        </th>
      ))}
    </tr>
  );
};

export default TableHeader;
